var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.3 162.3",
    style: {
      enableBackground: "new 0 0 162.3 162.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.85;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#94989D;}\r\n\t.st3{fill:#35CC62;}\r\n\t.st4{fill:#CC3737;}\r\n\t.st5{fill:#E89A1C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,162.3C36.4,162.3,0,125.9,0,81.2S36.4,0,81.2,0s81.2,36.4,81.2,81.2S125.9,162.3,81.2,162.3z M81.2,2 C37.5,2,2,37.5,2,81.2s35.5,79.2,79.2,79.2s79.2-35.5,79.2-79.2S124.8,2,81.2,2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,87.1v23.4H50.8V87.1H67.1 M67.1,85.6H50.8c-0.8,0-1.5,0.7-1.5,1.5v23.4c0,0.8,0.7,1.5,1.5,1.5h16.3 c0.8,0,1.5-0.7,1.5-1.5V87.1C68.6,86.3,67.9,85.6,67.1,85.6L67.1,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.3,69v41.5H73V69H89.3 M89.3,67.5H73c-0.8,0-1.5,0.7-1.5,1.5v41.5c0,0.8,0.7,1.5,1.5,1.5h16.3 c0.8,0,1.5-0.7,1.5-1.5V69C90.8,68.2,90.1,67.5,89.3,67.5L89.3,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.5,51.8v58.6H95.2V51.8H111.5 M111.5,50.3H95.2c-0.8,0-1.5,0.7-1.5,1.5v58.6c0,0.8,0.7,1.5,1.5,1.5h16.3 c0.8,0,1.5-0.7,1.5-1.5V51.8C113,51,112.3,50.3,111.5,50.3L111.5,50.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsInfoWhite);
export default __webpack_public_path__ + "static/media/ReportsInfo_white.06a1ff9b9f930aca772dd1860c56f170.svg";
export { ForwardRef as ReactComponent };